import { ShieldCheck } from 'lucide-react'
import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { useI18n } from '@/lib/i18n'

/** Hero: headline, subtitle and primary CTAs. */
export function Hero() {
  const { t, path } = useI18n()

  return (
    <section className="mx-auto max-w-7xl px-4 pb-20 pt-20 sm:px-6 md:pb-28 md:pt-28 lg:px-8">
      <div className="mx-auto flex max-w-3xl flex-col items-center text-center">
        <span className="inline-flex items-center gap-2 rounded-full border bg-card px-3 py-1 text-xs font-medium text-muted-foreground shadow-sm">
          <ShieldCheck className="h-3.5 w-3.5 text-primary" aria-hidden />
          {t('heroBadge')}
        </span>

        <h1 className="mt-8 text-5xl font-bold leading-[1.05] tracking-tight sm:text-6xl">
          {t('heroTitle1')}
          <br />
          <span className="text-primary">{t('heroTitle2')}</span>
          <br />
          {t('heroTitle3')}
        </h1>

        <p className="mt-6 max-w-xl text-lg leading-relaxed text-muted-foreground">
          {t('heroSubtitle')}
        </p>

        <div className="mt-10 flex flex-col gap-3 sm:flex-row">
          <Button asChild size="xl">
            <Link to={path('/tools/video-converter')}>{t('heroCtaStart')}</Link>
          </Button>
          <Button asChild variant="outline" size="xl">
            <Link to={path('/#tools')}>{t('heroCtaExplore')}</Link>
          </Button>
        </div>

        <p className="mt-8 text-xs text-muted-foreground">{t('heroNote')}</p>
      </div>
    </section>
  )
}